import { render, staticRenderFns } from "./AvaliationLike.vue?vue&type=template&id=15d05382&"
import script from "./AvaliationLike.vue?vue&type=script&lang=js&"
export * from "./AvaliationLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports